<template>
  <v-container fluid fill-height>
    <v-layout align-center justify-center text-center>
      <v-flex xs12 sm8 md4>
        <v-card>
          <v-card-title>
            <h3 style="margin-bottom:10px;">
              {{$t('views.forgotpassword.forgot_password')}}
            </h3>
          </v-card-title>
          <v-card-text>
            <v-form :disabled="loading" ref="form" v-model="valid">
              <no-autocomplete-textfield
                outlined
                v-model="email"
                :label="$t('headers.contacts.email')"
                :rules="[$rules.required, $rules.email]"
                class="required"
              ></no-autocomplete-textfield>
              <vue-recaptcha
                v-on:expired="recaptchaValid=false"
                v-on:verify="recaptchaCallback($event)"
                :sitekey="settings.SiteKey"
              ></vue-recaptcha>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-row>
              <v-col cols="3">
                <v-btn
                  color="primary"
                  text
                  block
                  @click="cancel"
                  >{{$t('globals.cancel')}}</v-btn
                >
              </v-col>
              <v-col cols="3">
                <v-btn
                  color="primary"
                  text
                  block
                  @click="$router.push({name: 'forgotEmail'})"
                  >{{$t('views.forgotemail.forgot_email')}}</v-btn
                >
              </v-col>
              <v-col cols="6">
                <v-btn
                  block
                  :disabled="!valid || !recaptchaValid || loading"
                  color="primary"
                  @click="handleSubmit"
                  >{{$t('components.membersmanagementtable.reset_password')}}</v-btn
                >
              </v-col>
            </v-row>
          </v-card-actions>
          <v-snackbar
            v-model="snackbar"
            :color="color"
            :multi-line="true"
            :timeout="6000"
            :vertical="true"
          >
            {{$t(message)}}
            <v-btn
              dark
              text
              @click="snackbar = false"
              >{{$t('globals.close')}}</v-btn
            >
          </v-snackbar>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import VueRecaptcha from 'vue-recaptcha';
import { mapGetters, mapActions } from "vuex";
import jwt from "jsonwebtoken";
import NoAutocompleteTextfield from "../components/NoAutocompleteTextfield";
export default {
  name: "register",
  data() {
    return {
      recaptchaValid: false,
      valid: false,
      email: "",
      loading: false,
      token:"",
      //snackbar
      snackbar:false,
      color:null,
      message:""
    };
  },
  watch: {
  },
  computed: {
    ...mapGetters("auth", ["user"]),
    ...mapGetters("common", { selectedPlan: "plan", settings: "settings" }),
    ...mapGetters("plansMembers", { planParameters: "planOptions" }),
    ...mapGetters("common", ["language"]),
  },
  methods: {
    ...mapActions("applicationUsers", ['resetForgotPassword','resetPasswordByEmail']),
    recaptchaCallback(event) {
      this.recaptchaValid = true
    },
    createToken(user) {
      let token = jwt.sign(
        {
          broker: user.BrokerId,
          id: user.Id
        },
        this.settings.RegistrationTokenSecret,
        {expiresIn: this.settings.TokenExpirationTime}
      );
      this.token = window.location.origin + "/#/reset-password/" + token
      return this.token;
    },
    displaySuccess(){
      this.color="success";
      this.message=this.$t("views.forgotpassword.success");
      this.snackbar=true;
      this.loading=false;
    },
    displayError(msg){
      this.color="error";
      this.message=this.$t(msg);
      this.snackbar=true;
      this.loading=false;
    },
    async handleSubmit() {
      try {
        this.loading = true;
        await this.resetForgotPassword({payload:{ Email:this.email, Language: this.language ? this.language.language :'en', Origin: window.location.origin}});
        this.displaySuccess();
      }
      catch(e) {
        console.log(e);
        this.errorMessage = e
      }
    },
    cancel(){
      window.location=window.location.origin+"/";
    }
  },
  components: { VueRecaptcha, NoAutocompleteTextfield }
};
</script>
